import React, { FC, useEffect, useState } from "react";
import { Button, Container, ModalBody, ModalHeader, Row } from "reactstrap";
import { openMaterialWindow } from "../../helpers/revitClient";
import MetsecModal from "../MetsecModal";

const MaterialImportModal: FC = () => {
  const [isOpen, setIsOpen] = useState(true);
  useEffect(() => {
    if (isOpen) {
      openMaterialWindow();
    }
  }, []);

  return (
    <MetsecModal isOpen={isOpen}>
      <ModalHeader toggle={() => setIsOpen(false)}>Material Import</ModalHeader>
      <ModalBody>
        <Container>
          {/* <Row>
            <video controls={true} autoPlay={true} loop={true} src="https://metframe3d.metsec.com/import-materials.mp4">
              <source
                src="https://metframe3d.metsec.com/import-materials.mp4"
                type="video/mp4"
              />
              <p>Video not supported</p>
            </video>
          </Row> */}
          <br />
          <Row>
            <h2>How to import materials</h2>
            <ol>
              <li>Drag the material library into the Revit window.</li>
              <li>Open the Material Browser inside of Revit.</li>
              <li>
                Open 3 pane view inside of the Material Browser. There should
                now be a list of imported materials shown.
              </li>
              <li>
                Select the "metsec-material" library and import the materials.
              </li>
            </ol>
          </Row>
          <Row>
            <Button onClick={openMaterialWindow}> Open Material File</Button>
          </Row>
        </Container>
      </ModalBody>
    </MetsecModal>
  );
};

export default MaterialImportModal;
